import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _Math$trunc from "@babel/runtime-corejs3/core-js/math/trunc";
import { computed, defineComponent, toRefs } from "@vue/composition-api";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
import { uniqueId } from "lodash";
import BaseLabel from "@Shared/components/form-elements/base/base-label.vue";
import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
export default defineComponent({
  name: "TimeAtFieldGroup",
  components: {
    TextField,
    BaseLabel
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    id: {
      type: String,
      default: () => uniqueId()
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasWarning: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    validator: {
      type: Object,
      default: null
    },
    warningMessage: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const {
      value
    } = toRefs(props);
    const {
      valueModel
    } = useCoreInput({
      value
    });
    const parseCombinedValue = (years, months) => {
      valueModel.value = _parseInt((years || 0).toString()) * 12 + _parseInt((months || 0).toString());
    };
    const yearsValue = computed({
      get() {
        return _Math$trunc(valueModel.value / 12);
      },
      set(value) {
        parseCombinedValue(value, monthsValue.value);
      }
    });
    const monthsValue = computed({
      get() {
        return valueModel.value % 12;
      },
      set(value) {
        parseCombinedValue(yearsValue.value, value);
      }
    });
    return {
      yearsValue,
      monthsValue
    };
  }
});